import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { Button, Label, Card, Icons, Text, Image } from "../../../design";
import {
  translate,
  translateIntervals,
  translateDateEpoch,
  translateLocalizedEntity,
} from "../../../utils/translations";
import {
  SUBSCRIPTION_STATUS_READABLE,
  DB_SUBSCRIPTION_STATUS_ACTIVE,
  DB_SUBSCRIPTION_STATUS_CANCELLED,
  DB_SUBSCRIPTION_STATUS_PAUSED,
  DB_SUBSCRIPTION_STATUS_EXPIRED,
} from "../../../utils/constants";
import { getVariantTitleDisplay } from "../../../utils/helpers";
import { useLoopAuth } from "../../auth-provider";
import { addDays, fromUnixTime } from "date-fns";
import { useLoop } from "../../loop-provider";
import useNavigationURL from "../../../hooks/useNavigationURL";

function GiftSubscriptionCard({ contract, customer_shopify_id }) {
  const router = useRouter();
  const { queryString, storeId } = useLoopAuth();
  const { locale, country, preferences } = useLoop();
  const navigationUrl = useNavigationURL();

  const [cancelledExpiredOrPaused, setcancelledExpiredOrPaused] = useState(true);

  useEffect(() => {
    let _cancelledPausedOrExpired = false;
    if (
      contract.status == DB_SUBSCRIPTION_STATUS_CANCELLED ||
      contract.status == DB_SUBSCRIPTION_STATUS_PAUSED ||
      contract.status == DB_SUBSCRIPTION_STATUS_EXPIRED
    ) {
      _cancelledPausedOrExpired = true;
    }
    setcancelledExpiredOrPaused(_cancelledPausedOrExpired);
  }, [contract]);

  const frequencyText = () => {
    return translate("subscription_plan_nonprepaid_label", {
      delivery_interval: translateIntervals(contract.delivery_policy.interval_count, contract.delivery_policy.interval.toLowerCase()),
    });
  };

  const getNextOrderDate = () => {
    if (contract.chargeOffset) {
      const _deliveryDate = addDays(fromUnixTime(contract.next_billing_date), contract.chargeOffset);
      return translateDateEpoch(Math.ceil(_deliveryDate.getTime() / 1000), preferences.date_display_internationalization_format, locale, country);
    } else {
      return translateDateEpoch(contract.next_billing_date, preferences.date_display_internationalization_format, locale, country);
    }
  };
  return (
    <Card
      color="dark"
      className="my-4"
      onClick={() => {
        router.push(
          `${navigationUrl}/customer/${customer_shopify_id}/gift/${contract.shopify_id}${queryString.length ? `?${queryString}` : ""
          }`
        );
      }}
    >
      <Card.Header>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <Text.P1 className="loop-text-muted">{"#" + contract.shopify_id}</Text.P1>
          <Label
            entity="subscription"
            dbStatus={contract.status}
            title={translateLocalizedEntity(
              "GIFT_SUBSCRIPTION",
              storeId,
              "gift_subscription_status_" + SUBSCRIPTION_STATUS_READABLE[contract.status],
              translate("gift_subscription_status_" + SUBSCRIPTION_STATUS_READABLE[contract.status]),
            )}
          />
        </div>
        {contract.status == DB_SUBSCRIPTION_STATUS_ACTIVE ||
          (contract.status == DB_SUBSCRIPTION_STATUS_PAUSED && contract.autoResume) ? (
          <div className="d-flex justify-content-between align-items-center mb-1">
            <Text.P1>
              {translate("next_order_date_label", {
                next_billing_date: getNextOrderDate(),
              }) + " "}
              <strong className="loop-contract-card-nbd">{getNextOrderDate()}</strong>
            </Text.P1>
          </div>
        ) : null}
        <div className="d-flex align-items-center">
          <Icons.Repeat />
          <Text.P2 className="ms-1">{frequencyText()}</Text.P2>
        </div>
      </Card.Header>
      <div className="row p-2">
        {contract.line_items.map((li: any, liIndex: number) => {
          let _break = null;
          if (liIndex > 0 && liIndex % 2 == 0) {
            _break = <div className="w-100 d-block"></div>;
          }
          return (
            <React.Fragment key={liIndex}>
              {_break}
              <div className="col-md" id={li.id}>
                <div className="d-flex align-items-center p-2">
                  <Image.ProductImage
                    size="sm"
                    className="me-3 flex-shrink-0"
                    src={li.variant_image}
                  />
                  <div>
                    <Text.P1>{li.title}</Text.P1>
                    <Text.P2>{getVariantTitleDisplay(li.variant_title)}</Text.P2>
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
      <Card.Footer>
        <div className="d-flex align-items-center justify-content-between">
          <Text.P1>
            {translateLocalizedEntity(
              "GIFT_SUBSCRIPTION",
              storeId,
              "listing_page_footer_page",
              "This is a gift subscription 🎁"
            )}
          </Text.P1>
          <Button
            size="sm"
            id='loop-gift-subscription-list-view-details-button'
            onClick={() => {
              router.push(`${navigationUrl}/customer/${customer_shopify_id}/gift/${contract.shopify_id}${router.query.merchantToken ? `?merchantToken=${router.query.merchantToken}` : ""}`);
            }}
          >
            {translate("subscription_listing_view_details_button")}
          </Button>
        </div>
      </Card.Footer>
    </Card>
  );
}

export default GiftSubscriptionCard;
